import ComponentList from 'components/Content/ComponentList/ComponentList';

export default ComponentList;
